"use client";

import { useDealership } from "@/contexts/DealershipContext";
import { redirect } from "next/navigation";
import { Box, CircularProgress } from "@mui/material";

// This page component only exists to redirect based on context
export default function DashboardRedirectPage() {
    const {
        filteredDealerReportingItems,
        filteredGroupReportingItems,
        filteredStandaloneItems,
        isUserInfoLoading,
    } = useDealership();

    if (typeof window !== "undefined") {
        const hostname = window.location.hostname.replace("www.", "");
        const pathname = window.location.pathname;

        const hasEnrollInHostname = hostname.includes("enroll");

        const allowedDomains = [
            "dev.cadaworkforcestudy.com",
            "cadaworkforcestudy.com",
            "dev.nadaworkforcestudy.com",
            "nadaworkforcestudy.com",
            "workforcestudy.com",
            "atdworkforcestudy.com",
            "enroll.cada.prod.ander.ai",
            "cada.prod.ander.ai",
            "cadaetudedelamaindoeuvre.com",
        ];
        const isAllowedDomainAtRoot = allowedDomains.includes(hostname) && pathname === "/";

        if (hasEnrollInHostname || isAllowedDomainAtRoot) {
            redirect("/landing");
        }
    }

    // Wait for user info to load before deciding where to redirect,
    // otherwise filtered nav items are empty and we'd always fall through
    // to /executive-summary
    if (isUserInfoLoading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    redirect(
        filteredDealerReportingItems.length > 0
            ? filteredDealerReportingItems[0].path
            : filteredGroupReportingItems.length > 0
              ? filteredGroupReportingItems[0].path
              : filteredStandaloneItems.length > 0
                ? filteredStandaloneItems[0].path
                : "/executive-summary"
    );
}
